import PlayButton from 'assets/icons/play-button.svg';
import RibbonText from 'modules/content-cms/components/ribbon-text';
import Image from "next/legacy/image";
import React from 'react';
import { ISectionVideoFields } from '../../../../global';
import ContentContainer from '../components/content-container';
import Title from '../components/title';
import styles from './video.module.css';

interface VideoProps extends ISectionVideoFields {
  disableSpacing: boolean;
}

const Video: React.FC<VideoProps> = ({
  title,
  hideTitle,
  subTitle,
  backgroundColor,
  videoId,
  disableSpacing,
  richTitle,
}) => {
  const [clicked, setClicked] = React.useState<boolean>(false);

  return (
    <ContentContainer
      disableSpacing={disableSpacing}
      backgroundColor={backgroundColor}
    >
      {richTitle ? (
        <>
          <RibbonText text={richTitle} />
          {subTitle && (
            <div className="text-center text-sm font-black uppercase leading-loose text-primary-main">
              {subTitle}
            </div>
          )}
        </>
      ) : title && hideTitle !== true ? (
        <>
          {subTitle && (
            <div className="text-center text-sm font-black uppercase leading-loose text-primary-main">
              {subTitle}
            </div>
          )}
          <Title>{title}</Title>
        </>
      ) : null}

      <div className="mx-auto w-full max-w-4xl">
        <div className={styles.responsive}>
          {clicked ? (
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
              frameBorder="0"
              title={title}
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <button
              onClick={() => {
                setClicked(true);
              }}
            >
              <Image
                src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
                layout="fill"
                alt={title}
                objectFit="cover"
                objectPosition="center"
              />
              <div className="absolute left-1/2 top-1/2 z-40 -ml-10 -mt-10 text-text-dark-bg-contrast-white">
                <PlayButton className="h-20 w-20 rounded-full shadow-xl" />
              </div>
            </button>
          )}
        </div>
      </div>
    </ContentContainer>
  );
};

export default Video;
